(function(){
  'use strict';

  angular.module('wml.portal.damage-form', []);
})();
